var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('v-textarea',{staticClass:"ma-0 pa-0 custom-text-field input-size",attrs:{"hide-details":"","name":"input-7-1","value":_vm.dataRow.name,"rows":"1"},on:{"change":function($event){return _vm.$emit('update', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }